package linkerpangoquipdb

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class CommonValuesQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun selectValue(id: String): Query<String> = SelectValueQuery(id) { cursor ->
    cursor.getString(0)!!
  }

  public fun <T : Any> selectCompleteValue(id: String, mapper: (
    id: String,
    value_: String,
    last_update: Long,
  ) -> T): Query<T> = SelectCompleteValueQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!
    )
  }

  public fun selectCompleteValue(id: String): Query<Common_values> = selectCompleteValue(id, ::Common_values)

  public fun <T : Any> selectAllValues(mapper: (
    id: String,
    value_: String,
    last_update: Long,
  ) -> T): Query<T> = Query(-1_882_407_303, arrayOf("common_values"), driver, "CommonValues.sq", "selectAllValues", "SELECT common_values.id, common_values.value, common_values.last_update FROM common_values") { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!
    )
  }

  public fun selectAllValues(): Query<Common_values> = selectAllValues(::Common_values)

  public fun selectLastUpdateAt(): Query<Long> = Query(-135_195_780, arrayOf("common_values"), driver, "CommonValues.sq", "selectLastUpdateAt", "SELECT last_update FROM common_values ORDER BY last_update DESC LIMIT 1") { cursor ->
    cursor.getLong(0)!!
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertValue(
    id: String,
    value_: String,
    last_update: Long,
  ): Long {
    val result = driver.execute(-1_953_962_710, """INSERT INTO common_values (id, value, last_update) VALUES (?, ?, ?)""", 3) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, value_)
          bindLong(parameterIndex++, last_update)
        }.await()
    notifyQueries(-1_953_962_710) { emit ->
      emit("common_values")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteValue(id: String): Long {
    val result = driver.execute(1_322_330_488, """DELETE FROM common_values WHERE id = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
        }.await()
    notifyQueries(1_322_330_488) { emit ->
      emit("common_values")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAllValues(): Long {
    val result = driver.execute(-556_547_414, """DELETE FROM common_values WHERE id != "LAST_DATABASE_MIGRATION_VERSION"""", 0).await()
    notifyQueries(-556_547_414) { emit ->
      emit("common_values")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateValue(
    value_: String,
    last_update: Long,
    id: String,
  ): Long {
    val result = driver.execute(1_870_706_970, """UPDATE common_values SET value = ?, last_update = ? WHERE id = ?""", 3) {
          var parameterIndex = 0
          bindString(parameterIndex++, value_)
          bindLong(parameterIndex++, last_update)
          bindString(parameterIndex++, id)
        }.await()
    notifyQueries(1_870_706_970) { emit ->
      emit("common_values")
    }
    return result
  }

  private inner class SelectValueQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("common_values", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("common_values", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-1_635_359_545, """SELECT value FROM common_values WHERE id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, id)
    }

    override fun toString(): String = "CommonValues.sq:selectValue"
  }

  private inner class SelectCompleteValueQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("common_values", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("common_values", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-271_357_682, """SELECT common_values.id, common_values.value, common_values.last_update FROM common_values WHERE id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, id)
    }

    override fun toString(): String = "CommonValues.sq:selectCompleteValue"
  }
}
